import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {IDataGeofence } from '../models/IDataGeofence'
@Injectable({
  providedIn: 'root'
})
export class PanelDetailGeofencesService {
  
  private keys: string[] = [];
  private values: string[] = [];
  private guid$: Subject<string> = new Subject<string>();
  private id$: Subject<string> = new Subject<string>();
  private subtitle$: Subject<string> = new Subject<string>();
  private keys$: Subject<string[]> = new Subject<string[]>();
  private values$: Subject<string[]> = new Subject<string[]>();
  private lastUpdate$: Subject<string> = new Subject<string>();
  isVisibleDetails$: Subject<boolean> = new Subject<boolean>();
  order: any[];
  dataType: any[];
  public isVisible: boolean = false;
  private isLoading$: Subject<boolean> = new Subject();

  constructor() {
    
  }
  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }

  setGuid(Id: string) {
    this.guid$.next(Id);
  }
  getGuid() {
    return this.guid$.asObservable();
  }
  getSubtitle(): Observable<string> {
    return this.subtitle$.asObservable();
  }
  setSubtitle(sub: string) {
    return this.subtitle$.next(sub);
  }
  getKeys(): Observable<string[]> {
    return this.keys$.asObservable();
  }
  getValues(): Observable<string[]> {
    return this.values$.asObservable();
  }
  setTitle(Id: string) {
    this.id$.next(Id);
  }
  getTitle() {
    console.log(this.id$);
    return this.id$.asObservable();
  }

  setLastUpdate(date: string) {
    this.lastUpdate$.next(date);
  }
  getLastUpdate() {
    return this.lastUpdate$.asObservable();
  }
  setData(properties: any) {
    console.log("SETDATA");
    var arrayMaster = Object.entries(properties);
    this.dataType = [];
    this.order = [];
    this.keys = [];
    this.values = [];
    arrayMaster.forEach((element) => {
      console.log(element[1]);
      var obe: IDataGeofence;
      obe = JSON.parse(JSON.stringify(element[1]));
      this.keys.push(obe.key);
      this.values.push(obe.value);
    });

    this.values$.next(this.values);
    this.keys$.next(this.keys);
  }

  setDataLast(properties: any[]) {
    console.log("SETDATALAST");
    var arrayMaster = Object.entries(properties);
    var row: any;
    this.keys = [];
    this.values = [];
    arrayMaster.forEach((element) => {
      console.log(element);
      var array = element.slice();
      var iterator = array.values();
      this.keys.push(iterator.next().value.toString());
      this.values.push(iterator.next().value.toString());
    });

    this.values$.next(this.values);
    this.keys$.next(this.keys);
  }
  checkVisibilityPopup(): Observable<boolean> {
    return this.isVisibleDetails$.asObservable();
  }
  setVisibilityPopup(op) {
    this.isVisible = op;
    this.isVisibleDetails$.next(op);
  }

}
